import React from 'react';
export function ProcessSection() {
  const steps = [{
    title: 'Nos escribís por WhatsApp',
    description: 'Contanos qué equipo tenés, qué marca y qué síntoma presenta. Puede ser texto, foto o audio. Sin formularios.'
  }, {
    title: 'Coordinamos la visita técnica',
    description: 'Agendamos una inspección in situ en tu planta o depósito, según tu disponibilidad y urgencia.'
  }, {
    title: 'Diagnóstico y presupuesto claro',
    description: 'Te damos el diagnóstico real y un presupuesto sin letra chica ni costos ocultos. Vos decidís.'
  }, {
    title: 'Tu equipo vuelve a trabajar',
    description: 'Ejecutamos la reparación o el mantenimiento y te dejamos todo funcionando al 100%.'
  }];
  return <section className="py-20 bg-white" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-137">
          <span className="inline-block px-4 py-1.5 rounded-full bg-lightBg text-primary font-semibold text-sm mb-4" data-id="element-138">
            ¿Cómo funciona?
          </span>
          <h2 className="text-gray-900 font-heading font-bold" data-id="element-139">
            Así de simple es trabajar con nosotros
          </h2>
        </div>

        <div className="max-w-5xl mx-auto relative" data-id="element-140">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-8 right-8 h-0.5 bg-gray-100 -z-10" data-id="element-141"></div>

          <div className="grid md:grid-cols-4 gap-8" data-id="element-142">
            {steps.map((step, index) => <div key={index} className="relative text-center md:text-left" data-id="element-143">
                <div className="flex flex-col items-center md:items-start" data-id="element-144">
                  <div className="w-16 h-16 rounded-full bg-whatsapp text-white flex items-center justify-center text-2xl font-bold font-heading mb-6 shadow-lg ring-4 ring-white" data-id="element-145">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 font-heading" data-id="element-146">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-[16px] leading-relaxed" data-id="element-147">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}